import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  tone?: 'light' | 'dark';
};
export function SectionHeading({
  eyebrow,
  title,
  intro,
  tone = 'light'
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <div className="mx-auto max-w-3xl text-center" data-id="element-330" data-mp="3k06x1v86utys">
      {eyebrow && <p className={`text-xs font-bold uppercase tracking-[0.18em] sm:text-sm ${dark ? 'text-gold' : 'text-gum'}`} data-id="element-331" data-mp="3k29j646802y8">
          {eyebrow}
        </p>}
      <h2 className={`mt-3 text-balance font-serif text-[32px] font-black leading-[1.1] sm:text-5xl ${dark ? 'text-white' : 'text-ink'}`} data-id="element-332" data-mp="gjq463cjytld">
        {title}
      </h2>
      {intro && <p className={`mt-4 text-lg leading-relaxed sm:text-xl ${dark ? 'text-white/80' : 'text-muted'}`} data-id="element-333" data-mp="6s2f293gxon2">{intro}</p>}
    </div>;
}